// GLOBAL STATES
const customModal = document.getElementById('custom_modal');
const customModalContent = customModal.querySelector('.custom-modal-content');
const MODAL_TYPES = ['custom-modal--bottom-center', 'custom-modal--center-center'];
let currentCollectionGridConfig = {
  desktop: 4,
  mobile: 2
};
// CUSTOM FUNCTIONS
function initCustomScrollingBar(scope = document) {
  scope.querySelectorAll('.custom-scrolling-bar.swiper').forEach(swiperEl => {
    if (!swiperEl.classList.contains('swiper-initialized')) {
      
      const loop = (swiperEl.dataset.loop || "").toLowerCase() === "true";
      const autoplayEnabled = (swiperEl.dataset.autoplay || "").toLowerCase() === "true";
      const delay = parseInt(swiperEl.dataset.delay, 10) || 5000;

      const autoplay = autoplayEnabled ? {
        delay: delay,
        disableOnInteraction: false,
      } : false;
      
      const swiper = new Swiper(swiperEl, {
        direction: 'horizontal',
        grabCursor: true,
        speed: 400,
        allowTouchMove: true,
        loop: loop,
        slidesPerView: 1,
        autoplay: autoplay,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
      });

      const setEqualHeight = () => {
        const slides = swiperEl.querySelectorAll('.swiper-slide');
        if (!slides.length) return;
        const maxHeight = Math.max(...Array.from(slides).map(s => s.offsetHeight));
        swiperEl.style.height = maxHeight + 'px';
        slides.forEach(s => (s.style.height = maxHeight + 'px'));
        swiper.update();
      };

      setEqualHeight();
      window.addEventListener('resize', setEqualHeight);
    }
  });
}

function initDrawerMenuTabs(scope = document) {
  const tabLinks = scope.querySelectorAll('.custom-drawer-menu__tab');
  const tabContents = scope.querySelectorAll('.custom-drawer-menu__tab-content');

  if (!tabLinks.length) return;

  tabLinks.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      const tabId = tab.getAttribute('data-tab');

      tabContents.forEach(content => {
        content.classList.remove('open');
      });

      tabLinks.forEach(link => {
        link.classList.remove('active');
      });

      const targetContent = scope.querySelector(`#${tabId}`);
      if (targetContent) {
        targetContent.classList.add('open');
      }

      tab.classList.add('active');
    });
  });
  const defaultTab = scope.querySelector('#defaultOpen') || tabLinks[0];
  if (defaultTab) defaultTab.click();
}

function customDrawerMenuLink() {
  const menuLinks = document.querySelectorAll('.drawer-menu__link-collapsible');

  menuLinks.forEach(link => {
    link.addEventListener('click', () => {
      const content = link.closest('li').querySelector('.drawer-menu__collapsible-content');

      document.querySelectorAll('.drawer-menu__collapsible-content.open').forEach(openContent => {
        if (openContent !== content) {
          openContent.style.maxHeight = null;
          openContent.classList.remove('open');
          openContent.closest('li').querySelector('.drawer-menu__link-collapsible').classList.remove('active');
        }
      });

      if (content.classList.contains('open')) {
        content.style.maxHeight = null;
        content.classList.remove('open');
        link.classList.remove('active');
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        content.classList.add('open');
        link.classList.add('active');
      }
    });
  });
}

function onCustomModalEscapeKey(element) {
  if (element.key === 'Escape') {
    hideCustomModal();
  }
}

function showCustomModal(html, options = {}) {
  const { type = 'bottom-center' } = options;
  MODAL_TYPES.forEach(cls => customModal.classList.remove(cls));
  customModal.classList.add(`custom-modal--${type}`);

  customModalContent.innerHTML = html;
  customModal.classList.remove('hidden');
  customModal.classList.add('modal-visible');

  const closeBtn = customModal.querySelector('.close-modal');
  if (closeBtn) {
    closeBtn.addEventListener('click', hideCustomModal);
  }
  const backdrop = customModal.querySelector('.custom-modal-backdrop');
  if (backdrop) {
    backdrop.addEventListener('click', hideCustomModal);
  }  
  document.addEventListener('keydown', onCustomModalEscapeKey);
}

function hideCustomModal() {
  customModal.classList.remove('modal-visible');
  customModal.classList.add('hidden');
  customModalContent.innerHTML = '';
  document.removeEventListener('keydown', onCustomModalEscapeKey);
}

// function initProductGridSwipers(scope = document) {
//   scope.querySelectorAll('.swiper.custom-product-grid-item--swiper').forEach((swiperEl) => {
//     if (!swiperEl.classList.contains('swiper-initialized')) {
//       new Swiper(swiperEl, {
//         direction: 'horizontal',
//         loop: true,
//         longSwipes: false,
//         parallax: true,
//         pagination: {
//           el: swiperEl.querySelector('.swiper-pagination'),
//           clickable: false,
//           dynamicBullets: true,
//           dynamicMainBullets: 1,
//         },
//         navigation: {
//           nextEl: swiperEl.querySelector('.swiper-button-next'),
//           prevEl: swiperEl.querySelector('.swiper-button-prev'),
//         },
//       });
//     }
//   });
// }

function initProductGridSwipers(scope = document) {
  scope.querySelectorAll('.swiper.custom-product-grid-item--swiper').forEach((swiperEl) => {
    if (!swiperEl.classList.contains('swiper-initialized')) {
      const swiper = new Swiper(swiperEl, {
        direction: 'horizontal',
        loop: true,
        longSwipes: false,
        parallax: true,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: false,
          dynamicBullets: true,
          dynamicMainBullets: 1,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
      });

      // Sync initial slide to whichever swatch is marked active, so a
      // sold-out first variant doesn't leave the image mismatched.
      const card = swiperEl.closest('.grid-product');
      const activeSwatch = card && card.querySelector('.custom-product-swatch.is-active');
      const mediaId = activeSwatch && activeSwatch.dataset.variantMediaId;

      if (mediaId) {
        const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
        const index = slides.findIndex((slide) => slide.dataset.mediaId == mediaId);

        if (index >= 0) {
          swiper.slideToLoop(index, 0, false);
        }
      }
    }
  });
}

function handleQuickShopClick(button) {
  const handle = button.dataset.productHandle;
  if (!handle) return;

  fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(product => {
      // const colorOption = product.options.find(o => ["color", "colour"].includes(o.name.toLowerCase()));
      // const colorIndex = colorOption ? product.options.findIndex(o => ["color", "colour"].includes(o.name.toLowerCase())) + 1 : null;

      // const sizeOption = product.options.find(o => ["size", "size (int)"].includes(o.name.toLowerCase()));
      // const sizeIndex = sizeOption ? product.options.findIndex(o => ["size", "size (int)"].includes(o.name.toLowerCase())) + 1 : null;
const getOptionName = (name) => name.toLowerCase().trim();

const colorIndexRaw = product.options.findIndex(o =>
  ["color", "colour"].includes(getOptionName(o.name))
);

const sizeIndexRaw = product.options.findIndex(o =>
  getOptionName(o.name).startsWith("size")
);

const colorOption = colorIndexRaw >= 0 ? product.options[colorIndexRaw] : null;
const sizeOption = sizeIndexRaw >= 0 ? product.options[sizeIndexRaw] : null;

const colorIndex = colorIndexRaw >= 0 ? colorIndexRaw + 1 : null;
const sizeIndex = sizeIndexRaw >= 0 ? sizeIndexRaw + 1 : null;

      let sizesHTML = "";
      if (sizeOption) {
        sizesHTML = `
          <p><strong>Available Sizes:</strong></p>
          <ul class="variant-list size-list">
            ${sizeOption.values.map(size => {
              const hasStock = product.variants.some(v => {
                return (!colorIndex || v[`option${colorIndex}`]) && 
                       v[`option${sizeIndex}`] === size && v.available;
              });
              return `
                <li>
                  <span 
                    class="variant-option ${hasStock ? '' : 'unavailable'}" 
                    data-option-type="size" 
                    data-option-value="${size}">
                    ${size}
                  </span>
                </li>
              `;
            }).join('')}
          </ul>
        `;
      }

      let colorsHTML = "";
      if (colorOption) {
        colorsHTML = `
          <p><strong>Available Colors:</strong></p>
          <ul class="variant-list color-list">
            ${colorOption.values.map(color => {
              const hasStock = product.variants.some(v => {
                return (!sizeIndex || v[`option${sizeIndex}`]) && 
                       v[`option${colorIndex}`] === color && v.available;
              });
              return `
                <li>
                  <span 
                    class="variant-option ${hasStock ? '' : 'unavailable'}" 
                    data-option-type="color" 
                    data-option-value="${color}">
                    ${color}
                  </span>
                </li>
              `;
            }).join('')}
          </ul>
        `;
      }

      if (!sizeOption && !colorOption) {
        showCustomModal('<p>No size or color options found for this product.</p>', { type: 'bottom-center' });
        return;
      }

      const modalContentHTML = `
        <div class="custom-quick-shop-html">
          <h2 class="product-title">${product.title}</h2>
          ${colorsHTML}
          ${sizesHTML}
          <button class="quick-add-to-cart-btn btn btn--full add-to-cart" disabled>Add to Cart</button>
        </div>
      `;

      showCustomModal(modalContentHTML, { type: 'bottom-center' });

      const modal = document.querySelector('.custom-quick-shop-html');
      const addToCartBtn = modal.querySelector('.quick-add-to-cart-btn');

      let selectedOptions = { size: null, color: null };

      function updateSizeAvailability(selectedColor) {
        if (!sizeIndex) return;

        modal.querySelectorAll('.variant-option[data-option-type="size"]').forEach(sizeEl => {
          const sizeValue = sizeEl.dataset.optionValue;

          const hasStock = product.variants.some(v =>
            v.available &&
            v[`option${sizeIndex}`] === sizeValue &&
            (!colorIndex || v[`option${colorIndex}`] === selectedColor)
          );

          sizeEl.classList.toggle('unavailable', !hasStock);

          if (!hasStock && sizeEl.classList.contains('active')) {
            sizeEl.classList.remove('active');
            selectedOptions.size = null;
          }
        });

        addToCartBtn.disabled = true;
        addToCartBtn.removeAttribute('data-variant-id');
      }

      function findMatchingVariant() {
        return product.variants.find(variant => {
          const matchSize = sizeIndex ? variant[`option${sizeIndex}`] === selectedOptions.size : true;
          const matchColor = colorIndex ? variant[`option${colorIndex}`] === selectedOptions.color : true;
          return matchSize && matchColor;
        });
      }

      modal.querySelectorAll('.variant-option').forEach(option => {
        option.addEventListener('click', () => {
          if (option.classList.contains('unavailable')) return;

          const optionType = option.dataset.optionType;
          const optionValue = option.dataset.optionValue;

          modal
            .querySelectorAll(`.variant-option[data-option-type="${optionType}"]`)
            .forEach(el => el.classList.remove('active'));

          option.classList.add('active');
          selectedOptions[optionType] = optionValue;

          if (optionType === 'color') {
            selectedOptions.size = null;
            modal
              .querySelectorAll('.variant-option[data-option-type="size"]')
              .forEach(el => el.classList.remove('active'));
            updateSizeAvailability(optionValue);
            addToCartBtn.disabled = true;
            addToCartBtn.removeAttribute('data-variant-id');
            return;
          }

          const matchedVariant = findMatchingVariant();
          if (matchedVariant && matchedVariant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.dataset.variantId = matchedVariant.id;
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.removeAttribute('data-variant-id');
          }
        });
      });

      addToCartBtn.addEventListener('click', () => {
        const variantId = addToCartBtn.dataset.variantId;
        if (!variantId) return;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(res => res.json())
          .then(data => {
            // console.log('Added to cart:', data);
            addToCartBtn.disabled = true;
            var cartDrawer = new theme.CartDrawer();
            hideCustomModal();
            cartDrawer.open();
          })
          .catch(err => console.error("Add to cart error:", err));
      });
    })
    .catch(err => console.error("Fetch error:", err));
}

function initQuickShopButtons(scope = document) {
  const buttons = scope.querySelectorAll('.quick-shop-btn:not([data-initialized])');
  buttons.forEach(button => {
    button.setAttribute('data-initialized', 'true');
    button.addEventListener('click', () => handleQuickShopClick(button));
  });
}

// function addToCart(variantId, quantity = 1) {
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json'
//     },
//     body: JSON.stringify({
//       id: variantId,
//       quantity: quantity
//     })
//   })
//   .then(res => res.json())
//   .then(data => {
//     console.log('Added to cart:', data);
//     var cartDrawer = new theme.CartDrawer();
//     hideCustomModal();
//     cartDrawer.open();
//   })
//   .catch(err => {
//     console.error('Add to cart failed:', err);
//     alert('Something went wrong while adding to cart');
//   });
// }

// document.addEventListener('click', function (e) {
//   const target = e.target.closest('[data-product-info]');
//   if (target && !target.classList.contains('unavailable')) {
//     const variantId = target.getAttribute('data-product-info');
//     if (variantId) {
//       addToCart(variantId);
//     }
//   }
// });

function removeItem(key) {
  event.preventDefault();
  var data = {
    quantity: 0,
    id: key
  }

  fetch(theme.routes.cartChange, {
    method: "POST",
    body: JSON.stringify(data),
    credentials: "same-origin",
    headers: {
        "Content-Type": "application/json"
    }
  }).then(e => e.json()).then(function(e) {
  if (422 === e.status || "bad_request" === e.status)
  ;
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
  .bind(this));
}

function applySavedGridLayout() {
  const savedLayout = localStorage.getItem('gridLayout');

  if (!savedLayout) return;

  try {
    const parsed = JSON.parse(savedLayout);

    if (parsed.desktop || parsed.mobile) {
      const currentCollectionGridConfig = {
        desktop: parsed.desktop || 4,
        mobile: parsed.mobile || 2,
      };

      const isMobile = window.innerWidth < 768;
      const device = isMobile ? 'mobile' : 'desktop';

      toggleColumns(currentCollectionGridConfig[device], device);
    }
  } catch (e) {
    console.warn('Invalid gridLayout data in localStorage');
  }
}

function toggleColumns(columns, device, animate = true) {
  currentCollectionGridConfig[device] = columns;
  localStorage.setItem('gridLayout', JSON.stringify(currentCollectionGridConfig));

  const gridItems = document.querySelectorAll('.grid__item.grid-product');
  const gridContainer = document.querySelector('#CollectionAjaxContent .grid.grid--uniform');

  if (!gridContainer) return;

  if (animate) gridContainer.style.opacity = '0';

  const updateColumns = () => {
    const gridBtn = document.querySelector('.desktop .see-toggler__button-grid');
    const squareBtn = document.querySelector('.desktop .see-toggler__button-square');
    const gridBtnSvg = document.querySelector('.mobile .see-toggler__button-grid svg');
    const squareBtnSvg = document.querySelector('.mobile .see-toggler__button-square svg');

    gridItems.forEach((item) => {
      const classList = item.classList;

      if (device === 'desktop') {
        if (!gridBtn || !squareBtn) return;

        if (columns === 2) {
          classList.remove('medium-up--one-quarter');
          classList.add('medium-up--one-half');
        } else if (columns === 4) {
          classList.remove('medium-up--one-half');
          classList.add('medium-up--one-quarter');
        }
      }

      if (device === 'mobile') {
        if (!gridBtnSvg || !squareBtnSvg) return;

        if (columns === 1) {
          classList.remove('small--one-half');
          classList.add('small--one-whole');
        } else if (columns === 2) {
          classList.remove('small--one-whole');
          classList.add('small--one-half');
        }
      }
    });

    if (device === 'desktop' && gridBtn && squareBtn) {
      gridBtn.classList.remove('toggle--active', 'toggle--inactive');
      squareBtn.classList.remove('toggle--active', 'toggle--inactive');

      if (columns === 2) {
        gridBtn.classList.add('toggle--inactive');
        squareBtn.classList.add('toggle--active');
      } else {
        gridBtn.classList.add('toggle--active');
        squareBtn.classList.add('toggle--inactive');
      }
    }

    if (device === 'mobile' && gridBtnSvg && squareBtnSvg) {
      gridBtnSvg.classList.remove('toggle--active', 'toggle--inactive');
      squareBtnSvg.classList.remove('toggle--active', 'toggle--inactive');

      if (columns === 1) {
        gridBtnSvg.classList.add('toggle--inactive');
        squareBtnSvg.classList.add('toggle--active');
      } else {
        gridBtnSvg.classList.add('toggle--active');
        squareBtnSvg.classList.add('toggle--inactive');
      }
    }

    if (animate) {
      setTimeout(() => {
        gridContainer.style.opacity = '1';
        if (typeof AOS !== 'undefined') AOS.refreshHard();
      }, 50);
    } else {
      gridContainer.style.opacity = '1';
      if (typeof AOS !== 'undefined') AOS.refreshHard();
    }
  };

  if (animate) {
    setTimeout(updateColumns, 100);
  } else {
    updateColumns();
  }
}

function initProductGridVideos(scope = document) {
  const videos = scope.querySelectorAll('video');

  videos.forEach(video => {
    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(() => {
        // iOS sometimes blocks autoplay until slight delay
        setTimeout(() => {
          video.play().catch(()=>{});
        }, 100);
      });
    }
  });
}

function initLoadMoreBtn() {
  const loadMoreBtn = document.getElementById('LoadMoreBtn');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      const button = this;
      const originalText = button.innerHTML;
      const nextPage = parseInt(button.dataset.nextPage, 10);
      const totalPages = parseInt(button.dataset.totalPages, 10);

      button.disabled = true;
      button.innerHTML = `<span class="loader"></span> Loading`;

      const url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);

      console.log("VIEW MORE LINK:" + url.toString());

      fetch(url.toString())
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
    
          const productGridItem = doc.querySelectorAll('div[data-product-id]');
          const productGridContainer = document.getElementById('ProductGridContainer');
    
productGridItem.forEach(div => {
  productGridContainer.appendChild(div);
});

initProductGridSwipers(productGridContainer);
initQuickShopButtons(productGridContainer);
initProductGridVideos(productGridContainer);

          const isMobile = window.innerWidth < 768;
          toggleColumns(
            currentCollectionGridConfig[isMobile ? 'mobile' : 'desktop'],
            isMobile ? 'mobile' : 'desktop',
            false
          );

          if (typeof AOS !== 'undefined') AOS.refreshHard();

          const next = nextPage + 1;
          button.dataset.nextPage = next.toString();

          if (next > totalPages) {
            button.style.display = 'none';
          } else {
            button.disabled = false;
            button.innerHTML = originalText;
          }
        })
        .catch(() => {
          button.disabled = false;
          button.innerHTML = originalText;
        });
    });
  }
}

function initScrollToTopButton() {
  const btn = document.getElementById('customScrollToTopBtn');
  if (!btn) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      btn.classList.add('show');
    } else {
      btn.classList.remove('show');
    }
  });

  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

function initCustomFancyBox() {
  Fancybox.bind("[data-fancybox]", {
    Carousel: {
    // Thumbs: false,
    Toolbar: {
      display: {
        left: [
          "counter"
        ],
        // middle: [
        //   "zoomIn",
        //   "zoomOut",
        //   "toggle1to1",
        //   "rotateCCW",
        //   "rotateCW",
        //   "flipX",
        //   "flipY",
        // ],
        right: [
          // "autoplay",
          // "thumbs",
          "close"
        ],
      },
    },
    Zoomable: {
      Panzoom: {
        maxScale: "cover",
        panMode: "mousemove",
        mouseMoveFactor: 1.1,
      },
    },
  },
  });
}

function initCustomCartSuggestion(scope = document) {
  scope.querySelectorAll('.custom-cart-suggestion .cart-suggestion__product-cards').forEach((swiperEl) => {
    if (!swiperEl.classList.contains('swiper-initialized')) {
      const autoplay = swiperEl.dataset.autoplay === "true" 
        ? {
            delay: parseInt(swiperEl.dataset.delay || "5000", 10),
            disableOnInteraction: true,
          }
        : false;

      const paginationEl = swiperEl.parentElement.querySelector('.swiper-pagination');

      new Swiper(swiperEl, {
        direction: 'horizontal',
        grabCursor: true,
        speed: 400,
        allowTouchMove: true,
        loop: true,
        slidesPerView: 1,
        autoplay: autoplay,
        pagination: {
          el: paginationEl,
          clickable: false,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
      });
    }
  });
}

function initCartSuggestionAddToCart(scope = document) {
  scope.querySelectorAll('.cart__item--add-to-cart').forEach((btn) => {
    if (!btn.dataset.listenerAttached) {
      btn.dataset.listenerAttached = "true";

      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.cartSuggestProductId;
        if (!variantId) {
          console.error("No product variant ID found on button.");
          return;
        }

        const payload = {
          items: [{ id: variantId, quantity: 1 }]
        };

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });

          if (!response.ok) {
            throw new Error('Failed to add item to cart');
          }

          await response.json();

          if (theme?.CartDrawer) {
            new theme.CartDrawer();
          }

        } catch (error) {
          Swal.fire({
            title: "Unable to add to cart",
            text: "Item already in cart or out of stock.",
            confirmButtonColor: "{{ settings.color_button | default: '#000000' }}",
          });
          console.error("Error adding to cart:", error);
        }
      });
    }
  });
}

function initCustomCarouselSwiper(scope = document) {
  scope.querySelectorAll('.swiper.custom-carousel-swiper').forEach((swiperEl) => {
    if (!swiperEl.classList.contains('swiper-initialized')) {
      const loop = swiperEl.dataset.loop === "true";
      const freeMode = swiperEl.dataset.freemode === "true";
      const autoHeight = swiperEl.dataset.autoheight === "true";
      const slidesPerView = parseFloat(swiperEl.dataset.slidesPerView || "1");
      const spaceBetween = parseInt(swiperEl.dataset.spaceBetween || "0");
      const autoplay = swiperEl.dataset.autoplay === "true"
        ? {
            delay: parseInt(swiperEl.dataset.delay || "5000", 10),
            disableOnInteraction: true,
          }
        : false;

      const swiperParent = swiperEl.parentElement.closest('.custom-carousel-container');
      const scrollbarEl = swiperEl.querySelector('.custom-swiper-scrollbar');
      const paginationEl = swiperEl.parentElement.querySelector('.custom-swiper-pagination');
      const nextEl = swiperParent?.querySelector('.custom-swiper-button-next');
      const prevEl = swiperParent?.querySelector('.custom-swiper-button-prev');

      const swiperConfig = {
        loop,
        spaceBetween,
        longSwipes: false,
        freeMode,
        autoplay,
        autoHeight,
        slidesPerView,
        breakpoints: {
          0: {
            slidesPerView: parseFloat(swiperEl.dataset.slidesPerViewMobile || "1"),
          },
          590: {
            slidesPerView: parseFloat(swiperEl.dataset.slidesPerViewTablet || "1"),
          },
          1050: {
            slidesPerView: slidesPerView,
          }
        },
      };
      if (nextEl && prevEl) {
        swiperConfig.navigation = { nextEl, prevEl };
      }
      if (scrollbarEl) {
        swiperConfig.scrollbar = {
          el: scrollbarEl,
          draggable: true,
        };
      }
      if (paginationEl && swiperEl.dataset.pagination !== "false") {
        swiperConfig.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      new Swiper(swiperEl, swiperConfig);
    }
  });
}

function initPageLoader() {
  const loader = document.getElementById("custom_page_loader");

  if (!loader) return;

  const removeLoader = () => {
    loader.classList.add("hidden");
    setTimeout(() => {
      loader.remove();
      document.body.classList.remove("custom-page-loader-loading");
    }, 300);
  };

  window.addEventListener("load", removeLoader, { once: true });

  setTimeout(removeLoader, 5000);
}

// INITIALIZE FUNCTIONS
function initThemeFeatures(scope = document) {
  if (scope === document) {
    applySavedGridLayout();
    initQuickShopButtons();
    initLoadMoreBtn();
    initScrollToTopButton();
    initCustomFancyBox();
    customDrawerMenuLink();
    initDrawerMenuTabs();
  }
  initProductGridSwipers(scope);
  initCustomCarouselSwiper(scope);
  initCustomCartSuggestion(scope);
  initCartSuggestionAddToCart(scope);
  initCustomScrollingBar(scope);
}

document.addEventListener('DOMContentLoaded', () => {
  initPageLoader();
  initThemeFeatures();
});

document.addEventListener('shopify:section:load', (event) => {
  initThemeFeatures(event.target);
});
